import type { BlockDef } from '../../prop-types.ts'
import { EMPTY_TEXT } from '../../text.ts'

/**
 * Questions and answers.
 *
 * New in this repository — not migrated. It earns its place for one reason: it is the block an AI is
 * *best* at filling in from a one-line business description, and the one a customer is least likely
 * to build by hand. "What are your opening hours", "do you deliver", "do you take mada" — a model
 * that knows the business type can draft all three, and the customer only has to correct them.
 */
export const faq: BlockDef = {
  type: 'faq',
  v: 1,
  label: { en: 'Questions', ar: 'الأسئلة الشائعة' },
  scope: 'page',
  description: 'Common questions with their answers, one under another.',
  whenToUse: 'Anything a customer asks before buying: delivery, payment, booking, parking, warranty, prices.',
  whenNotToUse: 'To pad a thin page. Three real questions beat ten invented ones, and an invented answer is a promise the business has to keep.',
  variants: [
    { value: 'list', label: { en: 'All open', ar: 'الكل مفتوح' } },
    { value: 'accordion', label: { en: 'Tap to open', ar: 'اضغط للفتح' } },
  ],
  fields: [
    { key: 'heading', label: { en: 'Heading', ar: 'العنوان' }, type: { kind: 'text' }, default: EMPTY_TEXT },
    {
      key: 'items',
      label: { en: 'Questions', ar: 'الأسئلة' },
      type: {
        kind: 'list',
        max: 20,
        item: [
          { key: 'question', label: { en: 'Question', ar: 'السؤال' }, type: { kind: 'text' }, default: EMPTY_TEXT },
          { key: 'answer', label: { en: 'Answer', ar: 'الإجابة' }, type: { kind: 'longText' }, default: EMPTY_TEXT },
        ],
      },
      default: [],
      requiredForPublish: true,
    },
  ],
}
